import { BASE_URL } from "../utils/BaseUrl";
import httpRequest from "../utils/httpsRequest";

export const TransactionId = async (payload) => {
    return await httpRequest(`${BASE_URL}/Transactions/${payload}`, "get" );
  }